
export const setTheme = (state, params) => {
	const { payload: clienteActivo } = params;
	state.clienteActivo = clienteActivo;
	return state;
};

export default {};